import {
  Box,
  Grid,
  FormControl,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  InputLabel,
  Backdrop,
  CircularProgress,
  Tooltip,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import PageTitle from "../../../components/PageTitle/PageTitle";
import useStyles from "../../../themes/style.js";
import { useNotification } from "../../../hooks/useNotification";
import axios from "axios";
import "../../../css/folder.css";
import {
  MdRemoveRedEye,
  MdFileDownload,
  MdLoop,
  MdPictureAsPdf,
  MdInsertDriveFile,
} from "react-icons/md";
import { AiFillFileWord, AiFillFileExcel } from "react-icons/ai";
import { GoPlus } from "react-icons/go";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useLocation } from "react-router-dom";
import { getFileExtension } from "../../../utils/getextension.js";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";
import CloseIcon from "@material-ui/icons/Close";
const AdminTaxDocument = () => {
  const classes = useStyles();
  const location = useLocation();
  const searchParam = new URLSearchParams(location.search);
  const userId = searchParam.get("userId");
  const [loader, setLoader] = useState(false);
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const [slots, setSlots] = useState([
    { slot: 1, reservedTo: "ADMIN", title: "Slot 1", fileUrl: null, id: null },
    { slot: 2, reservedTo: "ADMIN", title: "Slot 2", fileUrl: null, id: null },
    { slot: 3, reservedTo: "ADMIN", title: "Slot 3", fileUrl: null, id: null },
    { slot: 4, reservedTo: "ADMIN", title: "Slot 4", fileUrl: null, id: null },
    { slot: 5, reservedTo: "ADMIN", title: "Slot 5", fileUrl: null, id: null },
  ]);

  const [userSlots, setUserSlots] = useState([
    { slot: 1, reservedTo: "USER", title: "Slot 1", fileUrl: null, id: null },
    { slot: 2, reservedTo: "USER", title: "Slot 2", fileUrl: null, id: null },
    { slot: 3, reservedTo: "USER", title: "Slot 3", fileUrl: null, id: null },
    { slot: 4, reservedTo: "USER", title: "Slot 4", fileUrl: null, id: null },
    { slot: 5, reservedTo: "USER", title: "Slot 5", fileUrl: null, id: null },
    { slot: 6, reservedTo: "USER", title: "Slot 6", fileUrl: null, id: null },
    { slot: 7, reservedTo: "USER", title: "Slot 7", fileUrl: null, id: null },
    { slot: 8, reservedTo: "USER", title: "Slot 8", fileUrl: null, id: null },
    { slot: 9, reservedTo: "USER", title: "Slot 9", fileUrl: null, id: null },
    { slot: 10, reservedTo: "USER", title: "Slot 10", fileUrl: null, id: null },
  ]);
  const [currentSlot, setCurrentSlot] = useState(null);
  const [fileModalOpen, setFileModalOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState(false);
  const [currentEditId, setCurrentEditId] = useState("");
  const [editTaxDocumentModalOpen, setEditTaxDocumentModalOpen] = useState(
    false,
  );

  const handleFileModalClose = () => {
    setFileModalOpen(false);
    setFileUrl("");
  };

  const handleFileModalOpen = (url) => {
    setFileModalOpen(true);
    setFileUrl(url);
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    certificate: Yup.mixed()
      .required("Certificate is required")
      .test("fileType", "PDF, Word, Excel documents are allowed", (value) => {
        let fileValue = value;
        if (value instanceof FileList) {
          fileValue = value[0];
        }
        return (
          fileValue &&
          [
            "application/pdf",
            "application/msword",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ].includes(fileValue.type)
        );
      })
      .test("fileSize", "File size should not exceed 2MB", (value) => {
        let fileValue = value;
        if (value instanceof FileList) {
          fileValue = value[0];
        }
        return fileValue && fileValue.size <= 25 * 1024 * 1024;
      }),
  });

  const editValidationSchema = Yup.object().shape({
    id: Yup.string(),
    title: Yup.string().required("Title is required"),
    certificate: Yup.mixed()
      .required("Certificate is required")
      .test("fileType", "PDF, Word, Excel documents are allowed", (value) => {
        let fileValue = value;
        if (value instanceof FileList) {
          fileValue = value[0];
        }
        return (
          fileValue &&
          [
            "application/pdf",
            "application/msword",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          ].includes(fileValue.type)
        );
      })
      .test("fileSize", "File size should not exceed 2MB", (value) => {
        let fileValue = value;
        if (value instanceof FileList) {
          fileValue = value[0];
        }
        return fileValue && fileValue.size <= 25 * 1024 * 1024;
      }),
  });

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    register: editRegister,
    handleSubmit: editSubmit,
    setValue: editSetValue,
    reset: editReset,
    formState: { errors: editErrors, isSubmitting: editIsSubmitting },
  } = useForm({
    resolver: yupResolver(editValidationSchema),
  });

  const handleEditTaxDocModalOpen = (item) => {
    setEditTaxDocumentModalOpen(true);
    setCurrentSlot(item.slot);
    setCurrentEditId(item.id);
  };

  const handleEditTaxDocModalClose = () => {
    setEditTaxDocumentModalOpen(false);
    setCurrentSlot(null);
    editReset();
  };

  const handleFeedbackModalOpen = (slotId) => {
    setFeedbackModalOpen(true);
    setCurrentSlot(slotId);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
    setCurrentSlot(null);
  };

  // const handleFileChange = (e, slot) => {
  //   setSelectedFile(e.target.files[0]);
  //   const file = e.target.files[0];

  //   if (!file) {
  //     handleNotificationCall("error", "Upload Failed");
  //     return;
  //   }
  //   handleUpload(file, slot);
  //   console.log(selectedFile, e.target.files[0]);
  // };

  // const handleUpload = async (file, slot) => {
  //   var fileName = file.name.split(".").pop();

  //   if (fileName !== "pdf") {
  //     handleNotificationCall("error", "Invalid File Format");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("document", file);
  //   formData.append("reservedTo", "");
  //   formData.append("title", file);
  //   formData.append("slot", slot);

  //   try {
  //     const response = await axios.post(
  //       //   `${process.env.REACT_APP_SERVER}admin/uploadPolicyHandBook `,
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //           Authorization: token,
  //         },
  //       },
  //     );
  //     if (response.data.status) {
  //       handleNotificationCall("success", response.data.message);
  //       fetchData();
  //     }
  //   } catch (error) {
  //     setUploadStatus(
  //       `Upload failed: ${error.response?.data?.message || error.message}`,
  //     );
  //   }
  // };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_SERVER}employee/viewAllTaxDocument?userId=${userId}&page=1`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then((response) => {
      if (response.data.status) {
        const responseData = response.data.data;
        const adminSlotsDatas = responseData.filter(
          (item) => item.reservedTo === "ADMIN",
        );
        setSlots((prevSlots) =>
          prevSlots.map((slot) => {
            const fetchedSlot = adminSlotsDatas.find(
              (item) => item.slot === slot.slot,
            );
            return fetchedSlot
              ? {
                  ...slot,
                  fileUrl: fetchedSlot.fileUrl,
                  title: fetchedSlot.title,
                  id: fetchedSlot.id,
                }
              : slot;
          }),
        );

        const userSlotsDatas = responseData.filter(
          (item) => item.reservedTo === "USER",
        );
        setUserSlots((prevSlots) =>
          prevSlots.map((slot) => {
            const fetchedSlot = userSlotsDatas.find(
              (item) => item.slot === slot.slot,
            );
            return fetchedSlot
              ? {
                  ...slot,
                  fileUrl: fetchedSlot.fileUrl,
                  title: fetchedSlot.title,
                  id: fetchedSlot.id,
                }
              : slot;
          }),
        );
      }
    });
  };

  async function handleAdd(values) {
    setLoader(true);
    try {
      const thisFormData = new FormData();
      thisFormData.append("title", values.title);
      thisFormData.append("document", values.certificate[0]);
      thisFormData.append("userId", userId);
      thisFormData.append("slot", currentSlot);
      thisFormData.append("reservedTo", "ADMIN");

      const addResponse = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/addTaxDocument`,
        thisFormData,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        },
      );
      if (addResponse.data.status) {
        reset();
        setFeedbackModalOpen(false);
        handleNotificationCall("success", addResponse.data.message);
        fetchData();
        // const updatedSlots = slots.map((slot) =>
        //   slot.id === currentSlot
        //     ? { ...slot, fileUrl: "", title: values.title }
        //     : slot,
        // );
        // setSlots(updatedSlots);
      } else {
        handleNotificationCall("error", addResponse.data.message);
      }
    } catch (error) {
      console.log(error);
      handleNotificationCall("error", "Error Happend!");
    } finally {
      setLoader(false);
    }
  }

  async function handleEdit(values) {
    setLoader(true);
    try {
      const thisFormData = new FormData();
      thisFormData.append("id", currentEditId);
      thisFormData.append("title", values.title);
      thisFormData.append("document", values.certificate[0]);
      thisFormData.append("userId", userId);
      thisFormData.append("slot", currentSlot);
      thisFormData.append("reservedTo", "ADMIN");

      const addResponse = await axios.post(
        `${process.env.REACT_APP_SERVER}employee/editTaxDocument`,
        thisFormData,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        },
      );
      if (addResponse.data.status) {
        reset();
        setEditTaxDocumentModalOpen(false);
        handleNotificationCall("success", addResponse.data.message);
        fetchData();
      } else {
        handleNotificationCall("error", addResponse.data.message);
      }
    } catch (error) {
      console.log(error);
      handleNotificationCall("error", "Error Happend!");
    } finally {
      setLoader(false);
    }
  }

  const fileExtension = fileUrl ? getFileExtension(fileUrl) : null;

  return (
    <div style={{ marginTop: "20px" }}>

      <Box
        display="grid"
        gridTemplateColumns="auto"
        style={{ gap: "20px" }}
        mt={2}
        p={2}
      >
        <Typography variant="body2">Employee Documents</Typography>
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          style={{ gap: "20px" }}
        >
          {slots
            .filter((item) => item.reservedTo === "ADMIN")
            .map((item, index) => {
              const fileExtension = item.fileUrl && getFileExtension(item.fileUrl);

              let backgroundColor = "#fff"; // Default white background
              let borderColor = "#838383"; // Default white background
              let fileIcon = <MdInsertDriveFile size={24} color="#9e9e9e" />; // Default file icon

              switch (fileExtension) {
                case "pdf":
                  backgroundColor = "#ffe6e6";
                  borderColor = "#d20000";
                  fileIcon = <MdPictureAsPdf size={24} color="#d32f2f" />;
                  break;
                case "xls":
                case "xlsx":
                  backgroundColor = "#cbfacb";
                  borderColor = "#006900";
                  fileIcon = <AiFillFileExcel size={24} color="#2e7d32" />;
                  break;
                case "doc":
                case "docx":
                  backgroundColor = "#cbd6fa";
                  borderColor = "#005269";
                  fileIcon = <AiFillFileWord size={24} color="#1976d2" />;
                  break;
                default:
                  backgroundColor = "#fff";
                  borderColor = "#838383";
                  fileIcon = <MdInsertDriveFile size={24} color="#9e9e9e" />;
                  break;
              }
              return item.id ? (
                <div
                  className="admin-document-card"
                  style={{
                    background: backgroundColor,
                    borderColor: borderColor,
                  }}
                >
                  <span className="card_file_icon">{fileIcon}</span>
                  <div className="admin-document-card-content">
                    <div className="admin-document-card-title">
                      {item.title}
                    </div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-action-panel">
                      <Tooltip title="Replace document">
                        <p
                          className="replaceIcon"
                          onClick={() => handleEditTaxDocModalOpen(item)}
                        >
                          <MdLoop size={24} />
                        </p>
                      </Tooltip>
                      <Tooltip title="View document">
                        <p
                          className="viewIcon"
                          onClick={() => handleFileModalOpen(item.fileUrl)}
                        >
                          <MdRemoveRedEye size={24} />
                        </p>
                      </Tooltip>
                      <Tooltip title="Download document">
                        <a
                          href={item.fileUrl}
                          target="_blank"
                          rel="noreferrer"
                          download
                          className="downloadIcon"
                        >
                          <MdFileDownload size={24} />
                        </a>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ) : (
                <label
                  className="admin-document-upload-card"
                  onClick={() => handleFeedbackModalOpen(item.slot)}
                >
                  <div className="admin-document-upload-content">
                    <button className="add_tax_button_design">
                      <GoPlus />
                    </button>
                    <div style={{ textAlign: "center" }}>
                      <Typography variant="body2" style={{ fontSize: "12px" }}>
                        Slot - {item.slot}
                      </Typography>
                      Upload File
                    </div>
                  </div>
                </label>
              );
            })}
        </Box>

        <Typography variant="body2">Documents Uploaded by Employee</Typography>
        <Box
          display="flex"
          flexDirection="row"
          flexWrap="wrap"
          style={{ gap: "20px" }}
        >
          {userSlots
            .filter((item) => item.reservedTo === "USER")
            .map((item, index) => {
              const fileExtension = item.fileUrl && getFileExtension(item.fileUrl);

              let backgroundColor = "#fff"; // Default white background
              let borderColor = "#838383"; // Default white background
              let fileIcon = <MdInsertDriveFile size={24} color="#9e9e9e" />; // Default file icon

              switch (fileExtension) {
                case "pdf":
                  backgroundColor = "#ffe6e6";
                  borderColor = "#d20000";
                  fileIcon = <MdPictureAsPdf size={24} color="#d32f2f" />;
                  break;
                case "xls":
                case "xlsx":
                  backgroundColor = "#cbfacb";
                  borderColor = "#006900";
                  fileIcon = <AiFillFileExcel size={24} color="#2e7d32" />;
                  break;
                case "doc":
                case "docx":
                  backgroundColor = "#cbd6fa";
                  borderColor = "#005269";
                  fileIcon = <AiFillFileWord size={24} color="#1976d2" />;
                  break;
                default:
                  backgroundColor = "#fff";
                  borderColor = "#838383";
                  fileIcon = <MdInsertDriveFile size={24} color="#9e9e9e" />;
                  break;
              }

              return item.id ? (
                <div
                  className="admin-document-card"
                  style={{
                    background: backgroundColor,
                    borderColor: borderColor,
                  }}
                >
                  <span className="card_file_icon">{fileIcon}</span>
                  <div className="admin-document-card-content">
                    <div className="admin-document-card-title">
                      {item.title}
                    </div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-action-panel">
                      <p className="replaceIcon"></p>
                      <Tooltip title="View document">
                        <p
                          className="viewIcon"
                        onClick={() => handleFileModalOpen(item.fileUrl)}
                        >
                          <MdRemoveRedEye size={24} />
                        </p>
                      </Tooltip>
                      <Tooltip title="Download document">
                        <a
                          href={item.fileUrl}
                          target="_blank"
                          rel="noreferrer"
                          download
                          className="downloadIcon"
                        >
                          <MdFileDownload size={24} />
                        </a>
                      </Tooltip>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="admin-document-card">
                  <div className="admin-document-card-content">
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-title">
                      No Data Found
                    </div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                    <div className="admin-document-card-line"></div>
                  </div>
                </div>
              );
            })}
        </Box>

        <Dialog
          open={feedbackModalOpen}
          fullWidth
          maxWidth="xs"
          onClose={handleFeedbackModalClose}
          aria-labelledby="form-dialog-title"
        >
          <form onSubmit={handleSubmit(handleAdd)}>
            <h3 style={{ padding: "12px 12px", margin: 0 }}>
              Document: Slot -{" "}{currentSlot}
            </h3>
            {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="title">
                    Title
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter Subject"
                      name="title"
                      {...register("title")}
                      error={errors.title ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.title?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="description">
                    File
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      type="file"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      onChange={(e) => {
                        setValue("certificate", e.target.files);
                      }}
                      error={errors.certificate ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {errors.certificate?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ padding: "12px 24px" }}>
              <Button
                onClick={handleFeedbackModalClose}
                variant="contained"
                color="secondary"
                size="small"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
              >
                Send
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        <Dialog
          open={editTaxDocumentModalOpen}
          fullWidth
          maxWidth="xs"
          onClose={handleEditTaxDocModalClose}
          aria-labelledby="form-dialog-title"
        >
          <form onSubmit={editSubmit(handleEdit)}>
            <h3 style={{ padding: "12px 12px", margin: 0 }}>
              Document: Slot -{" "}{currentSlot}
            </h3>
            {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="title">
                    Title
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      placeholder="Enter Subject"
                      name="title"
                      {...editRegister("title")}
                      error={editErrors.title ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {editErrors.title?.message}
                    </Typography>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                  <InputLabel shrink htmlFor="description">
                    File
                  </InputLabel>
                  <FormControl className={classes.margin}>
                    <TextField
                      size="small"
                      type="file"
                      InputProps={{ disableUnderline: true }}
                      classes={{ root: classes.customTextField }}
                      onChange={(e) => {
                        editSetValue("certificate", e.target.files);
                      }}
                      error={editErrors.certificate ? true : false}
                    />

                    <Typography variant="inherit" color="error">
                      {editErrors.certificate?.message}
                    </Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ padding: "12px 24px" }}>
              <Button
                onClick={handleEditTaxDocModalClose}
                variant="contained"
                color="secondary"
                size="small"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                type="submit"
              >
                Send
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        <Dialog
          aria-labelledby="dialog-title"
          onClose={handleFileModalClose}
          open={fileModalOpen}
          fullWidth={true}
          maxWidth="md"
          PaperProps={{
            style: {
              width: "100%",
            },
          }}
        >
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <div
                className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
              >
                <Typography variant="subtitle2" className={classes.inputRoot}>
                  Employee Document
                </Typography>
                <div className={classes.pdfModalCloseBtn}>
                  <CloseIcon
                    className={classes.closeBtn}
                    onClick={handleFileModalClose}
                  />
                </div>
              </div>
              <Grid item xs={12}>
                {fileExtension === "pdf" ? (
                  <CustomPdfView resumeUrl={fileUrl} />
                ) : (
                  <div
                    className={classes.iframediv}
                    style={{ marginTop: "40px" }}
                  >
                    <iframe
                      src={
                        "https://docs.google.com/a/umd.edu/viewer?url=" +
                        fileUrl +
                        "&embedded=true"
                      }
                      title="File"
                      width="100%"
                      height="500"
                      sandbox="allow-scripts allow-same-origin"
                    ></iframe>
                    <div className={classes.iframeLogo}></div>
                  </div>
                )}
              </Grid>

              <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={handleFileModalClose}
                >
                  Close
                </Button>
              </div>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* Drag and Drop Zone */}
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
    </div>
  );
};

export default AdminTaxDocument;
